<template>
  <div class='HomeScreen-container'>
    <MobileHomeView v-if="isMobile"></MobileHomeView>
    <PCHomeView v-else></PCHomeView>
  </div>
</template>

<script>
import MobileHomeView from '@/components/MobileHomeView'
import PCHomeView from '@/components/PCHomeView'

export default {
  name: 'HomeScreen',
  components: {
    MobileHomeView,
    PCHomeView
  },
  data () {
    return {
      isMobile: false
    }
  },
  created () {
    // eslint-disable-next-line no-unused-expressions
    this.isMobile = navigator.appVersion.indexOf('Mobile') > -1
  },
  methods: {}
}
</script>

<style scoped lang='less'>
.HomeScreen-container {
}
</style>
